import { useContext } from "react";
import { UserStateContext } from "../providers/UserStateProvider";

export default function useUserState() {
  return useContext(UserStateContext);
}
